#import "../fragments/user-email-fragment.graphql"

mutation SetSmtpMailSendIsEnabled($userEmailId: ID!, $isEnabled: Boolean!) {
    setSmtpMailSendIsEnabled(
        input: {mailSend: {userEmailId: $userEmailId, isEnabled: $isEnabled}}
    ) {
        emailAddresses {
            ...UserEmail
        }
    }
}
